/**
 * „Coco erklärt“ im Agentur-Portal (docs/COCO.md, 02.10.2026): beim ersten Besuch einer Hauptseite eine kurze Karte mit dem,
 * was die Seite zeigt, und zwei, drei Hinweisen. Gleiche Einstellungen wie im Creator-Portal (user_preferences.onboarding),
 * die Schlüssel tragen das Präfix „agentur_“. Rein und ohne Datenbank, damit Tests die Zuordnung prüfen.
 * Die Texte selbst stehen seit dem Rundgang (20.10.2026) mit allen anderen Coco-Texten in coco-rundgang-texte.ts.
 */
import type { AgenturGuide } from "./coco-rundgang-texte";

export { agenturGuideText, studioGuideText, type AgenturGuide, type AgenturGuideText } from "./coco-rundgang-texte";

export function agenturGuideFor(pathname: string): AgenturGuide | null {
  const p = pathname.replace(/\/+$/, "");
  if (p === "/agentur") return "overview";
  const map: [string, AgenturGuide][] = [
    ["/agentur/kooperationen", "kooperationen"], ["/agentur/anfragen", "anfragen"], ["/agentur/vertraege", "vertraege"], ["/agentur/rechnungen", "rechnungen"],
    ["/agentur/auszahlungen", "auszahlungen"], ["/agentur/creator", "creator"], ["/agentur/marken", "marken"], ["/agentur/content", "content"],
    ["/agentur/kalender", "kalender"], ["/agentur/nachrichten", "nachrichten"], ["/agentur/kennzahlen", "kennzahlen"], ["/agentur/creator/pitch", "pitch"], ["/agentur/hub", "hub"],
    // Einstellungen: am Handy die Liste, am Desktop die erste Seite (Firma; nur für Admins gezeigt)
    ["/agentur/einstellungen", "einstellungen"], ["/agentur/einstellungen/firma", "einstellungen"],
  ];
  // Nur die Listen selbst, nicht Formulare und Detailseiten (dort stört die Karte)
  for (const [base, key] of map) if (p === base) return key;
  return null;
}
